/* gorilla-ugc-modal.js */
(function () {
  'use strict';

  var scrollY = 0;
  var activeVideo = null;
  var videoUrls = [];
  var currentIndex = 0;
  var videoGen = 0; // incremented each openModal call so stale event listeners self-cancel

  function lockScroll() {
    scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + scrollY + 'px';
    document.body.style.width = '100%';
    document.body.style.overflowY = 'scroll';
  }

  function unlockScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.overflowY = '';
    window.scrollTo(0, scrollY);
  }

  function youtubeId(url) {
    var m = url.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{6,15})/);
    return m ? m[1] : null;
  }

  function vimeoId(url) {
    var m = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    return m ? m[1] : null;
  }

  function isDirectVideo(url) {
    return /\.(mp4|webm|mov|m4v)(\?|$)/i.test(url);
  }

  function clearMedia(mediaWrap) {
    while (mediaWrap.firstChild) {
      mediaWrap.removeChild(mediaWrap.firstChild);
    }
  }

  function makeSvgEl(ns, tag, attrs) {
    var el = document.createElementNS(ns, tag);
    Object.keys(attrs).forEach(function (k) { el.setAttribute(k, attrs[k]); });
    return el;
  }

  function updateMuteIcon() {
    var iconEl = document.getElementById('gorilla-ugc-mute-icon');
    if (!iconEl || !activeVideo) return;
    var ns = 'http://www.w3.org/2000/svg';
    while (iconEl.firstChild) iconEl.removeChild(iconEl.firstChild);
    iconEl.appendChild(makeSvgEl(ns, 'polygon', { points: '11 5 6 9 2 9 2 15 6 15 11 19 11 5' }));
    if (activeVideo.muted) {
      iconEl.appendChild(makeSvgEl(ns, 'line', { x1: '23', y1: '9',  x2: '17', y2: '15' }));
      iconEl.appendChild(makeSvgEl(ns, 'line', { x1: '17', y1: '9',  x2: '23', y2: '15' }));
    } else {
      iconEl.appendChild(makeSvgEl(ns, 'path', { d: 'M19.07 4.93a10 10 0 0 1 0 14.14' }));
      iconEl.appendChild(makeSvgEl(ns, 'path', { d: 'M15.54 8.46a5 5 0 0 1 0 7.07' }));
    }
  }

  function openModal(videoUrl) {
    var modal     = document.getElementById('gorilla-ugc-modal');
    var mediaWrap = document.getElementById('gorilla-ugc-media');
    var playOver  = document.getElementById('gorilla-ugc-play-overlay');
    var muteBtn   = document.getElementById('gorilla-ugc-mute');
    if (!modal || !mediaWrap) return;

    videoGen++;
    var myGen = videoGen;

    clearMedia(mediaWrap);
    activeVideo = null;
    if (playOver) playOver.classList.remove('gorilla-ugc-modal__play-overlay--visible');

    var ytId     = youtubeId(videoUrl);
    var viId     = vimeoId(videoUrl);

    if (ytId) {
      var iframe = document.createElement('iframe');
      iframe.className = 'gorilla-ugc-modal__iframe';
      iframe.src = 'https://www.youtube.com/embed/' + ytId + '?autoplay=1&playsinline=1&rel=0';
      iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
      iframe.setAttribute('allowfullscreen', '');
      mediaWrap.appendChild(iframe);
      if (playOver) playOver.style.display = 'none';
      if (muteBtn)  muteBtn.classList.add('gorilla-ugc-modal__mute--hidden');

    } else if (viId) {
      var iframe = document.createElement('iframe');
      iframe.className = 'gorilla-ugc-modal__iframe';
      iframe.src = 'https://player.vimeo.com/video/' + viId + '?autoplay=1&playsinline=1';
      iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
      iframe.setAttribute('allowfullscreen', '');
      mediaWrap.appendChild(iframe);
      if (playOver) playOver.style.display = 'none';
      if (muteBtn)  muteBtn.classList.add('gorilla-ugc-modal__mute--hidden');

    } else {
      var video = document.createElement('video');
      video.className = 'gorilla-ugc-modal__video';
      video.src = videoUrl;
      video.setAttribute('playsinline', '');
      video.loop = true;
      video.muted = false;

      if (playOver) {
        playOver.style.display = '';
        playOver.classList.remove('gorilla-ugc-modal__play-overlay--visible');
        video.addEventListener('play',  function () {
          if (myGen !== videoGen) return;
          playOver.classList.remove('gorilla-ugc-modal__play-overlay--visible');
        });
        video.addEventListener('pause', function () {
          if (myGen !== videoGen) return;
          playOver.classList.add('gorilla-ugc-modal__play-overlay--visible');
        });
        video.addEventListener('click', togglePlay);
      }

      mediaWrap.appendChild(video);
      activeVideo = video;

      video.play().catch(function () {
        if (myGen !== videoGen) return;
        if (playOver) playOver.classList.add('gorilla-ugc-modal__play-overlay--visible');
      });

      if (muteBtn) {
        muteBtn.classList.remove('gorilla-ugc-modal__mute--hidden');
        updateMuteIcon();
      }
    }

    var alreadyOpen = modal.classList.contains('gorilla-ugc-modal--open');
    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('gorilla-ugc-modal--open');
    if (!alreadyOpen) lockScroll();

    var closeBtn = modal.querySelector('.gorilla-ugc-modal__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeModal() {
    var modal     = document.getElementById('gorilla-ugc-modal');
    var mediaWrap = document.getElementById('gorilla-ugc-media');
    if (!modal) return;

    modal.setAttribute('aria-hidden', 'true');
    modal.classList.remove('gorilla-ugc-modal--open');
    unlockScroll();

    if (activeVideo) {
      activeVideo.pause();
      activeVideo = null;
    }
    if (mediaWrap) clearMedia(mediaWrap);
  }

  function togglePlay() {
    if (!activeVideo) return;
    if (activeVideo.paused) { activeVideo.play(); } else { activeVideo.pause(); }
  }

  function toggleMute() {
    if (!activeVideo) return;
    activeVideo.muted = !activeVideo.muted;
    updateMuteIcon();
  }

  document.addEventListener('DOMContentLoaded', function () {
    var modal = document.getElementById('gorilla-ugc-modal');
    if (!modal) return;

    document.body.appendChild(modal);

    modal.querySelectorAll('[data-ugc-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });

    var playBtn = document.getElementById('gorilla-ugc-play-btn');
    if (playBtn) playBtn.addEventListener('click', togglePlay);

    var playOverlay = document.getElementById('gorilla-ugc-play-overlay');
    if (playOverlay) playOverlay.addEventListener('click', function (e) {
      if (e.target === playOverlay) togglePlay();
    });

    var muteBtn = document.getElementById('gorilla-ugc-mute');
    if (muteBtn) muteBtn.addEventListener('click', toggleMute);

    var cards = document.querySelectorAll('[data-ugc-open]');
    videoUrls = [];
    cards.forEach(function (card, i) {
      var url = card.getAttribute('data-ugc-open');
      if (url) videoUrls.push(url);
      card.addEventListener('click', function () {
        currentIndex = videoUrls.indexOf(url);
        if (url) { openModal(url); updateNavButtons(); }
      });
    });

    var prevBtn = document.getElementById('gorilla-ugc-prev');
    var nextBtn = document.getElementById('gorilla-ugc-next');

    function updateNavButtons() {
      if (prevBtn) prevBtn.disabled = false;
      if (nextBtn) nextBtn.disabled = false;
    }

    if (prevBtn) prevBtn.addEventListener('click', function () {
      currentIndex = (currentIndex - 1 + videoUrls.length) % videoUrls.length;
      openModal(videoUrls[currentIndex]);
    });

    if (nextBtn) nextBtn.addEventListener('click', function () {
      currentIndex = (currentIndex + 1) % videoUrls.length;
      openModal(videoUrls[currentIndex]);
    });

    document.addEventListener('keydown', function (e) {
      if (!modal.classList.contains('gorilla-ugc-modal--open')) return;
      if (e.key === 'ArrowLeft' && prevBtn && !prevBtn.disabled) prevBtn.click();
      if (e.key === 'ArrowRight' && nextBtn && !nextBtn.disabled) nextBtn.click();
    });
  });
})();
